jQuery(document).ready(function ($) {
  // Carousel navigation and scroll handling
  $('.carousel-section').each(function () {
    const $section = $(this);
    const $track = $section.find('.carousel-track');
    const $prev = $section.find('.carousel-prev');
    const $next = $section.find('.carousel-next');

    if (!$track.length || !$prev.length || !$next.length) {
      return;
    }

    const updateNav = function () {
      const maxScroll = $track[0].scrollWidth - $track.outerWidth();

      if (maxScroll <= 0) {
        $prev.attr('hidden', true);
        $next.attr('hidden', true);
        return;
      }

      $prev.removeAttr('hidden');
      $next.removeAttr('hidden');
    };

    const scrollAmount = function () {
      const slide = $track.find('.carousel-slide').first();
      if (!slide.length) {
        return $track.outerWidth();
      }

      const gap = parseFloat(window.getComputedStyle($track[0]).columnGap) || 0;
      return slide.outerWidth() + gap;
    };

    $prev.on('click', function () {
      const current = $track.scrollLeft();
      const maxScroll = $track[0].scrollWidth - $track.outerWidth();
      const target = current <= 5 ? maxScroll : Math.max(0, current - scrollAmount());
      $track.animate({ scrollLeft: target }, 300);
    });

    $next.on('click', function () {
      const current = $track.scrollLeft();
      const maxScroll = $track[0].scrollWidth - $track.outerWidth();
      const target = current >= maxScroll - 5 ? 0 : Math.min(maxScroll, current + scrollAmount());
      $track.animate({ scrollLeft: target }, 300);
    });

    $track.on('scroll resize', updateNav);
    $(window).on('resize load', updateNav);
    $section.on('mouseenter', updateNav);
    $track.find('img').on('load', updateNav);

    // initial state
    updateNav();
  });
});
